import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformSDKFieldMaskToRESTFieldMask } from '@wix/sdk-runtime/transformations/field-mask';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixEventsTicketingTicketDefinitionManagementUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www.wixapis.com': [
      {
        srcPath: '/events/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/events/v2/ticket-definitions',
        destPath: '/v2/ticket-definitions',
      },
      {
        srcPath: '/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/events/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/events/v2/ticket-definitions',
        destPath: '/v2/ticket-definitions',
      },
      {
        srcPath: '/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v2/ticket-definitions',
        destPath: '/v2/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/events-ticketing-v1-proxy',
        destPath: '/api',
      },
    ],
    _: [
      {
        srcPath: '/_api/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v2/ticket-definition',
        destPath: '/v2/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/events-ticketing-v1-proxy/v1',
        destPath: '/v1',
      },
      {
        srcPath: '/_api/events-ticketing-v1-proxy/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v2/ticket-definitions',
        destPath: '/v2/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v2/ticket-definitions',
        destPath: '/v2/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v2/ticket-definitions',
        destPath: '/v2/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
    ],
    '*.pub.wix-code.com': [
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    'api._base_domain_': [
      {
        srcPath: '/events/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    'editor-flow.wixapps.net': [
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_events_ticket-definitions';

/**
 * **Deprecated.** This function will continue to work until November 8, 2024, but a newer version is available. Use [`queryTicketDefinitions()`](/ticket-definitions-v2/query-ticket-definitions) function instead.
 * >**Migration Instructions**.
 * > If this function is already in your code, it will continue to work. To stay compatible with future changes, migrate to [`queryTicketDefinition()`](/ticket-definitions-v2/query-ticket-definitions).
 * > To migrate to the new function:
 * > 1. Add the new import statement:
 * > ```js
 * > import { ticketDefinitionsV2 } from 'wix-events.v2';
 * > ```
 * > 2. Look for any code that uses `ticketDefinitions.queryTicketDefinition()`, and replace it with `ticketDefinitionsV2.queryTicketDefinition()`. Update your code to work with the new `createTicketDefinition()` response properties.
 * > 3. Test your changes to make sure your code behaves as expected.
 *
 * Retrieves a list of up to 100 ticket definitions.
 * @deprecated Will be removed on 2024-12-01.
 */
export function queryTicketDefinitions(
  payload: object
): RequestOptionsFactory<any> {
  function __queryTicketDefinitions({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.ticket_definition',
      method: 'POST' as any,
      methodFqn:
        'wix.events.ticketing.TicketDefinitionManagement.QueryTicketDefinitions',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingTicketDefinitionManagementUrl({
        protoPath: '/v1/ticket-definitions/query',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'definitions.salePeriod.startDate' },
              { path: 'definitions.salePeriod.endDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __queryTicketDefinitions;
}

/**
 * **Deprecated.** This function will continue to work until October 29, 2024, but a newer version is available at [`queryTicketDefinitions()`](/ticket-definitions-v2/query-ticket-definitions).
 * >**Migration Instructions**.
 * > If this function is already in your code, it will continue to work. To stay compatible with future changes, migrate to [`queryTicketDefinitions()`](/ticket-definitions-v2/query-ticket-definitions).
 * > To migrate to the new function:
 * > 1. Add the new import statement:
 * > ```js
 * > import { ticketDefinitionsV2 } from 'wix-events.v2';
 * > ```
 * > 2. Look for any code that uses `ticketDefinitions.queryTicketDefinitions()`, and replace it with `ticketDefinitionsV2.queryTicketDefinitions()`. Update your code to work with the new `queryTicketDefinition()` response properties.
 * > 3. Test your changes to make sure your code behaves as expected.
 *
 * Retrieves a list of up to 1,000 ticket definitions, given the provided paging and filtering.
 * @deprecated Will be removed on 2024-12-01.
 */
export function queryTicketDefinitionsV2(
  payload: object
): RequestOptionsFactory<any> {
  function __queryTicketDefinitionsV2({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.ticket_definition',
      method: 'POST' as any,
      methodFqn:
        'wix.events.ticketing.TicketDefinitionManagement.QueryTicketDefinitionsV2',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingTicketDefinitionManagementUrl({
        protoPath: '/v2/ticket-definitions/query',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'definitions.salePeriod.startDate' },
              { path: 'definitions.salePeriod.endDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __queryTicketDefinitionsV2;
}

/**
 * **Deprecated.** This function will continue to work until November 8, 2024, but a substitute is available. Use the [`queryTicketDefinitions()`](/ticket-definitions-v2/query-ticket-definitions) function instead.
 * >**Migration Instructions**.
 * > If this function is already in your code, it will continue to work. To stay compatible with future changes, migrate to [`queryTicketDefinitions()`](/ticket-definitions-v2/query-ticket-definitions).
 * > To migrate to the new function:
 * > 1. Add the new import statement:
 * > ```js
 * > import { ticketDefinitionsV2 } from 'wix-events.v2';
 * > ```
 * > 2. Look for any code that uses `ticketDefinitions.queryTicketDefinitions()`, and replace it with `ticketDefinitionsV2.queryTicketDefinitions()`. Update your code to work with the new `queryTicketDefinition()` response properties.
 * > 3. Test your changes to make sure your code behaves as expected.
 *
 * Retrieves a list of up to 100 ticket definitions, with basic filter support.
 * @deprecated Will be removed on 2024-12-01.
 */
export function listTicketDefinitions(
  payload: object
): RequestOptionsFactory<any> {
  function __listTicketDefinitions({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.ticket_definition',
      method: 'GET' as any,
      methodFqn:
        'wix.events.ticketing.TicketDefinitionManagement.ListTicketDefinitions',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingTicketDefinitionManagementUrl({
        protoPath: '/v1/ticket-definitions',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'definitions.salePeriod.startDate' },
              { path: 'definitions.salePeriod.endDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __listTicketDefinitions;
}

/**
 * **Deprecated.** This function will continue to work until November 8, 2024, but a newer version is available. Use the [`getTicketDefinition()`](/ticket-definitions-v2/get-ticket-definition) function instead.
 * >**Migration Instructions**.
 * > If this function is already in your code, it will continue to work. To stay compatible with future changes, migrate to [`getTicketDefinition()`](/ticket-definitions-v2/get-ticket-definition).
 * > To migrate to the new function:
 * > 1. Add the new import statement:
 * > ```js
 * > import { ticketDefinitionsV2 } from 'wix-events.v2';
 * > ```
 * > 2. Look for any code that uses `ticketDefinitions.getTicketDefinition()`, and replace it with `ticketDefinitionsV2.getTicketDefinition()`. Update your code to work with the new `getTicketDefinition()` response properties.
 * > 3. Test your changes to make sure your code behaves as expected.
 *
 * Retrieves a ticket definition.
 * @deprecated Will be removed on 2024-12-01.
 */
export function getTicketDefinition(
  payload: object
): RequestOptionsFactory<any> {
  function __getTicketDefinition({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.ticket_definition',
      method: 'GET' as any,
      methodFqn:
        'wix.events.ticketing.TicketDefinitionManagement.GetTicketDefinition',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingTicketDefinitionManagementUrl({
        protoPath: '/v1/ticket-definitions/{definitionId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'definition.salePeriod.startDate' },
              { path: 'definition.salePeriod.endDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getTicketDefinition;
}

/**
 * **Deprecated.** This function will continue to work until November 8, 2024, but a newer version is available. Use the [`createTicketDefinition()`](/ticket-definitions-v2/create-ticket-definition) function instead.
 * >**Migration Instructions**.
 * > If this function is already in your code, it will continue to work. To stay compatible with future changes, migrate to [`createTicketDefinition()`](/ticket-definitions-v2/create-ticket-definition).
 * > To migrate to the new function:
 * > 1. Add the new import statement:
 * > ```js
 * > import { ticketDefinitionsV2 } from 'wix-events.v2';
 * > ```
 * > 2. Look for any code that uses `ticketDefinitions.createTicketDefinition()`, and replace it with `ticketDefinitionsV2.createTicketDefinition()`. Update your code to work with the new `createTicketDefinition()` response properties.
 * > 3. Test your changes to make sure your code behaves as expected.
 *
 * Creates a ticket definition (and enables ticket sales).
 * @deprecated Will be removed on 2024-12-01.
 */
export function createTicketDefinition(
  payload: object
): RequestOptionsFactory<any> {
  function __createTicketDefinition({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'definition.salePeriod.startDate' },
          { path: 'definition.salePeriod.endDate' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.events.v1.ticket_definition',
      method: 'POST' as any,
      methodFqn:
        'wix.events.ticketing.TicketDefinitionManagement.CreateTicketDefinition',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingTicketDefinitionManagementUrl({
        protoPath: '/v1/ticket-definitions',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'definition.salePeriod.startDate' },
              { path: 'definition.salePeriod.endDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __createTicketDefinition;
}

/**
 * **Deprecated.** This function will continue to work until November 8, 2024, but a newer version is available. Use the [`updateTicketDefinition()`](/ticket-definitions-v2/update-ticket-definition) function instead.
 * >**Migration Instructions**.
 * > If this function is already in your code, it will continue to work. To stay compatible with future changes, migrate to [`updateTicketDefinition()`](/ticket-definitions-v2/update-ticket-definition).
 * > To migrate to the new function:
 * > 1. Add the new import statement:
 * > ```js
 * > import { ticketDefinitionsV2 } from 'wix-events.v2';
 * > ```
 * > 2. Look for any code that uses `ticketDefinitions.updateTicketDefinition()`, and replace it with `ticketDefinitionsV2.updateTicketDefinition()`. Update your code to work with the new `updateTicketDefinition()` response properties.
 * > 3. Test your changes to make sure your code behaves as expected.
 *
 *
 * Updates a ticket definition.
 *
 * See [Partial Updates](/wix-events-v2/partial-updates) for more information.
 * @deprecated Will be removed on 2024-12-01.
 */
export function updateTicketDefinition(
  payload: object
): RequestOptionsFactory<any> {
  function __updateTicketDefinition({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'fields' }],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'definition.salePeriod.startDate' },
          { path: 'definition.salePeriod.endDate' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.events.v1.ticket_definition',
      method: 'PATCH' as any,
      methodFqn:
        'wix.events.ticketing.TicketDefinitionManagement.UpdateTicketDefinition',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingTicketDefinitionManagementUrl({
        protoPath: '/v1/ticket-definitions/{definitionId}',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'definition.salePeriod.startDate' },
              { path: 'definition.salePeriod.endDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __updateTicketDefinition;
}

/**
 * **Deprecated.** This function will continue to work until November 8, 2024, but a newer version is available. Use the [`deleteTicketDefinition()`](/ticket-definitions-v2/delete-ticket-definition) function instead.
 * >**Migration Instructions**.
 * > If this function is already in your code, it will continue to work. To stay compatible with future changes, migrate to [`deleteTicketDefinition()`](/ticket-definitions-v2/delete-ticket-definition).
 * > To migrate to the new function:
 * > 1. Add the new import statement:
 * > ```js
 * > import { ticketDefinitionsV2 } from 'wix-events.v2';
 * > ```
 * > 2. Look for any code that uses `ticketDefinitions.deleteTicketDefinition()`, and replace it with `ticketDefinitionsV2.deleteTicketDefinition()`. Update your code to work with the new `deleteTicketDefinition()` response properties.
 * > 3. Test your changes to make sure your code behaves as expected.
 *
 * Deletes a ticket definition.
 * @deprecated Will be removed on 2024-12-01.
 */
export function deleteTicketDefinition(
  payload: object
): RequestOptionsFactory<any> {
  function __deleteTicketDefinition({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.ticket_definition',
      method: 'DELETE' as any,
      methodFqn:
        'wix.events.ticketing.TicketDefinitionManagement.DeleteTicketDefinition',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingTicketDefinitionManagementUrl({
        protoPath: '/v1/ticket-definitions',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __deleteTicketDefinition;
}

/**
 * **Deprecated.** This function will continue to work until November 8, 2024, but a newer version is available at [`changeCurrency()`](/ticket-definitions-v2/change-currency).
 * >**Migration Instructions**.
 * > If this function is already in your code, it will continue to work. To stay compatible with future changes, migrate to [`changeCurrency()`](/ticket-definitions-v2/change-currency).
 * > To migrate to the new function:
 * > 1. Add the new import statement:
 * > ```js
 * > import { ticketDefinitionsV2 } from 'wix-events.v2';
 * > ```
 * > 2. Look for any code that uses `ticketDefinitions.changeCurrency()`, and replace it with `ticketDefinitionsV2.changeCurrency()`. Update your code to work with the new `changeCurrency()` response properties.
 * > 3. Test your changes to make sure your code behaves as expected.
 *
 * Changes the currency for all tickets per event.
 * @deprecated Will be removed on 2024-12-01.
 */
export function changeCurrency(payload: object): RequestOptionsFactory<any> {
  function __changeCurrency({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.ticket_definition',
      method: 'PUT' as any,
      methodFqn:
        'wix.events.ticketing.TicketDefinitionManagement.ChangeCurrency',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingTicketDefinitionManagementUrl({
        protoPath: '/v1/ticket-definitions/currency',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __changeCurrency;
}
